import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useTipsPerProvider = (params, options = {}) => {
  return useQuery(
    ["tipsPerProviderReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTipReport(), {
        params,
      });
      const composeResponse = {
        clinics: res.data.data.clinics,
        reportHeader: res.data.data.report_header,
        reportData: Object.values(res.data.data.report_data),
        total: res.data.data.total,
      };
      return composeResponse;
    },
    options,
  );
};
